import React from "react";
import { useNavigate } from "react-router-dom";
import { SearchContentModel } from "../SearchContent/SearchContentModel";
import SearchItemUtils from "./SearchItemUtils";

import "./SearchItem.css";
import Utils from "../../core/Utils/Utils";

const SearchItem: React.FC<{ blok: SearchContentModel }> = ({ blok }) => {
  const navigate = useNavigate();
  if (!blok?.content?.body) {
    return null;
  }
  const item = blok.content;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (blok.full_slug) {
      navigate(`/${blok.full_slug}`);
    }
  };

  return (
    <div className="search-item-comp">
      <div className="item-image" onClick={handleClick}>
        {item.image?.filename && (
          <img
            src={Utils.getCacheUrl(item.image?.filename)}
            alt=""
            onError={(e) => Utils.handleImageError(e, item.image?.filename)}
          />
        )}
      </div>
      <div className="item-content" onClick={handleClick}>
        <div className="item-title">{item.shortTitle}</div>
        <div className="item-subtitle">{item.standfirst}</div>
        {SearchItemUtils.getButtonLabel(blok) && (
          <div className="item-action">
            <span>{SearchItemUtils.getButtonLabel(blok)}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchItem;
